import { Stack, type StackProps } from '@mui/material'

export function Section(props: StackProps) {
  const { children, ...rest } = props

  return (
    <Stack spacing={2} {...rest}>
      {children}
    </Stack>
  )
}
